import React, {Component} from 'react';
import { Card, CardBody, Table, CardHeader } from 'reactstrap';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import {FaEdit, FaTrash} from "react-icons/fa";
import {Link} from "react-router-dom";

class ServiceGroupEmailComponent extends Component {

    listEmail = () => {
        if ( this.props.groupEmail.emails.length ) {
            return (
                this.props.groupEmail.emails.map( (email, key) => (
                    <tr key={key}>
                        <td>{ key + 1 }</td>
                        <td>
                            <Link to={ "/admin/email/" + email.id  + "/chinh-sua-email.html"}>
                                { email.title }
                            </Link>
                        </td>
                        <td className="text-right">
                            <OverlayTrigger
                                delay={{ hide: 450, show: 300 }}
                                overlay={(props) => (
                                    <Tooltip {...props}>
                                        Chỉnh sửa
                                    </Tooltip>
                                )}
                                placement="top"
                            >
                                <Link className="btn btn-warning btn-sm mr-1 text-light" to={ "/admin/email/" + email.id  + "/chinh-sua-email.html"}>
                                    <FaEdit />
                                </Link>
                            </OverlayTrigger>
                            <OverlayTrigger
                                delay={{ hide: 450, show: 300 }}
                                overlay={(props) => (
                                    <Tooltip {...props}>
                                        Xóa email
                                    </Tooltip>
                                )}
                                placement="top"
                            >
                                <button type="button" className="btn btn-danger btn-sm mr-1" onClick={ () => this.props.showModal( email, 'deleteProduct' ) }>
                                    <FaTrash />
                                </button>
                            </OverlayTrigger>
                        </td>
                    </tr>
                ))
            )
        }
        else {
            return (
                <tr>
                    <td colSpan={15} className="text-center text-danger">
                        Không có dữ liệu email của nhóm { this.props.groupEmail.title }
                    </td>
                </tr>
            )
        }
    }

    render() {
        return (
            <Card className="email-group">
                <CardHeader className="row">
                    <div className="col-8 m-0">
                        <h5 className="m-0">
                            { this.props.groupEmail.title }
                        </h5>
                    </div>
                    <div className="col-4 text-right  m-0">
                        <OverlayTrigger
                            delay={{ hide: 450, show: 300 }}
                            overlay={(props) => (
                                <Tooltip {...props}>
                                    Chỉnh sửa
                                </Tooltip>
                            )}
                            placement="top"
                        >
                            <button type="button" className="btn btn-warning btn-sm mr-1 text-light" onClick={ () => this.props.showModal( this.props.keyAction, 'editGroup' ) }>
                                <FaEdit />
                            </button>
                        </OverlayTrigger>
                        <OverlayTrigger
                            delay={{ hide: 450, show: 300 }}
                            overlay={(props) => (
                                <Tooltip {...props}>
                                    Xóa nhóm email
                                </Tooltip>
                            )}
                            placement="top"
                        >
                            <button type="button" className="btn btn-danger btn-sm mr-1" onClick={ () => this.props.showModal( this.props.keyAction, 'deleteGroup' ) }>
                                <FaTrash />
                            </button>
                        </OverlayTrigger>
                    </div>
                </CardHeader>
                <CardBody>
                    <Table className="table table-hover table-bordered">
                        <thead>
                        <tr>
                            <td width="5%">#</td>
                            <td width="70%">Tiêu đề</td>
                            <td width="25%" className="text-right">Hành động</td>
                        </tr>
                        </thead>
                        <tbody>
                            { this.listEmail() }
                        </tbody>
                    </Table>
                </CardBody>
            </Card>
        );
    }
}

export default ServiceGroupEmailComponent;